import { Component, Input, OnInit } from '@angular/core';
import { ProductsService } from 'src/app/_services/products.service';

@Component({
  selector: 'app-feature-image-upload',
  templateUrl: './feature-image-upload.component.html',
  styleUrls: ['./feature-image-upload.component.scss']
})
export class FeatureImageUploadComponent implements OnInit {
  @Input() placeholder = 'https://preview.keenthemes.com/metronic8/demo2/assets/media/svg/files/blank-image.svg';
  @Input() imageData: string | null = null;

  fileToUpload: File | null = null;

  constructor(public _productService: ProductsService) {}

  ngOnInit(): void {
    if (!this.imageData) {
      this.imageData = this._productService.featureImage || this.placeholder;
    }
  }

  handleFileInput(event: any) {
    try {
      const file = event.target.files?.item(0);
      if (!file) return;
      this.fileToUpload = file;
      const reader = new FileReader();
      reader.onload = (ev: any) => {
        this.imageData = ev.target.result;
        this._productService.featureImage = this.imageData;
      };
      reader.readAsDataURL(file);
    } catch {}
  }

  removeImage() {
    this.imageData = this.placeholder;
    this._productService.featureImage = null;
  }
}
